export enum PhoneAiConfigEnum {
    CallSettings,
    CallJourneys,
    Outcomes,
    Assurance,
    HumanTransfer,
    Knowledge,
    Notifications,
    Testing,
    Processes
}
